/** Киргизский язык — навигация, подвал, куки, 404 */
export const layoutKy: Record<string, string> = {
  "nav.logoAria": "IT-24.pro башкы бет",
  "nav.devops": "Кызматтар",
  "nav.admin": "Аудит",
  "nav.support": "Шашылыш жардам",
  "nav.vps": "Байланыш",
  "nav.k8s": "Долбоорлор",
  "nav.cicd": "Кейстер",
  "nav.ddos": "Менин жөнүндө",
  "nav.llmops": "Retainer",
  "nav.packages": "Кызматтар",
  "nav.audience": "Кимдер үчүн",
  "nav.cases": "Кейстер",
  "nav.portfolio": "Кейстер",
  "nav.contacts": "Байланыш",
  "nav.auditCta": "Telegramга жазуу",
  "nav.auditCtaShort": "Telegram",
  "nav.ariaMain": "Негизги навигация",
  "nav.langSwitcherAria": "Тилди тандоо",
  "nav.menuOpen": "Менюну ачуу",
  "nav.menuClose": "Менюну жабуу",
  "nav.langRu": "RU",
  "nav.langUk": "UA",
  "nav.langKk": "KZ",
  "nav.langUz": "UZ",
  "nav.langKy": "KG",

  "footer.tagline":
    "Криптовалюта сектору, финтех жана highload үчүн инфраструктура. PL юридикалык жак · Telegram.",
  "footer.badge1": "✓ PCI / DDoS / K8s",
  "footer.badge2": "✓ USDT / инвойс",
  "footer.badge3": "✓ 2010-жылдан бери инфраструктурада",
  "footer.consultCta": "Telegramга жазуу",
  "footer.servicesTitle": "Кызматтар",
  "footer.tariffsHome": "Башкы беттеги кызматтар",
  "footer.devops": "DevOps retainer",
  "footer.serverSupport": "Шашылыш жардам",
  "footer.serverAdmin": "Аудит",
  "footer.k8s": "PCI / DDoS / K8s долбоорлору",
  "footer.cicd": "Кейстер",
  "footer.ddos": "Менин жөнүндө",
  "footer.llmops": "Байланыш",
  "footer.vps": "nexops.eu (EU)",
  "footer.vacancies": "Telegram",
  "footer.contactTitle": "Байланыш",
  "footer.location": "Konin, Poland",
  "footer.copy": "Бардык укуктар корголгон.",
  "footer.taglineBottom": "Криптовалюта сектору · финтех · highload · Telegram",

  "cookie.title": "Биз сиздин тажрыйбаңызды жакшыртуу үчүн cookie файлдарын колдонобуз",
  "cookie.body":
    "Биз сайтты ыңгайлуу колдонуу жана айрым функциялардын иштеш үчүн cookie файлдарын колдонобуз. Сайтты улантуу менен, сиз cookie колдонууга макул болосуз.",
  "cookie.reject": "Баш тартуу",
  "cookie.accept": "Кабыл алуу",

  "notFound.title": "Баракча табылмады | IT-24.pro",
  "notFound.description":
    "Мындай баракча жок. Криптовалюта сектору жана финтех үчүн инфраструктура — башкы бетте.",
  "notFound.h1": "Баракча табылмады",
  "notFound.text":
    "Шилтеме эскириши мүмкүн — эски кызматтар жаңы бөлүмдөргө өткөрүлдү.",
  "notFound.home": "Башкы бетке",
  "notFound.devops": "Retainer / кызматтар",

  "breadcrumb.home": "Башкы бет",
  "breadcrumb.devopsServices": "Кызматтар",
  "breadcrumb.ariaLabel": "Навигация",

  "search.title": "Сайт боюнча издөө | IT-24.pro",
  "search.titleWithQuery": "Издөө: {query} | IT-24.pro",
  "search.description": "IT-24.pro'до retainer, аудит, PCI, DDoS, Kubernetes издөө.",
  "search.h1": "Сайт боюнча издөө",
  "search.lead": "Кызматты табыңыз: шашылыш жардам, аудит, retainer, долбоорлор.",
  "search.placeholder": "Мисалы: pci, ddos, retainer",
  "search.submit": "Издөө",
  "search.prompt": "Суроону жазыңыз — ылайык бөлүмдөрдү көрсөтөбүз.",
  "search.resultsCount": "Табылды: {count}",
  "search.noResults": "«{query}» боюнча эч нерсе табылган жок.",
  "search.emptyHint": "Башка ачкыч сөздөрдү же кызматтар бөлүмүнө өтүңүз.",
};
